import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://yvsoqivtcb.execute-api.us-east-1.amazonaws.com/dev';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('authToken');
        window.location.href = '/';
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject({ message: 'Network error. Please check your connection.' });
  }
);

export async function getColleges() {
  const response = await api.post('/booking/get_colleges', { action: 'get_colleges' });
  return response.data;
}

export async function getBookingStatus(bookingId) {
  const response = await api.post('/booking/get_booking_status', {
    action: 'get_booking_status',
    booking_id: bookingId,
  });
  return response.data;
}

export async function getAssessment(assessmentId) {
  const response = await api.post('/assessment/get_assessment', {
    action: 'get_assessment',
    assessment_id: assessmentId,
  });
  return response.data;
}

export async function submitContactForm(formData) {
  const response = await api.post('/contact/submit', formData);
  return response.data;
}

export default api;
